module.exports = __webpack_public_path__ + "static/media/Header_split.d6450707.mp4";